import {useEffect, useState} from "react";
import axios from "../../utils/api/axios";
import {useParams} from "react-router-dom";
import {IAM_PATH} from "../../utils/Config";
import Loading from "../../utils/loading/Loading";
import {DialogEnum, showDialog} from "../../utils/dialog/Dialog";
import styles from './Login.module.css';

/**
 * 관리자 최초 등록 화면
 * @constructor
 */
export const Init = () => {
    const {date} = useParams()

    const [status, setStatus] = useState(null); //등록 요청 결과 상태 (성공/실패)
    const [responseData, setResponseData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setStatus("중 ...");

        const url = IAM_PATH+"/init/admin";
        const requestData = { date: date }

        axios.get(url, {params: requestData})
            .then((res) => {
                setStatus("성공");
                setResponseData(res.data);
            })
            .catch((e) =>{
                showDialog(DialogEnum.DEFAULT, "관리자 등록 실패", e.response.data.resultMessage);
                setStatus("실패");
                setResponseData("다시 시도해 주세요.")
            })

        setLoading(false);
    }, []); //deps 배열을 비우게 되면, 컴포넌트가 처음 나타날 때에만 useEffect에 등록한 함수가 호출됨 (중복 방지)



    return (
        <>
            {loading ? <Loading/>
                :
                <div className={styles.login}>
                    <div className={styles.login__box}>
                        <h3>관리자 등록 {status}</h3>
                        <h4>{responseData}</h4>
                    </div>
                </div>
            }
        </>

    );
}

export default Init;
